import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed";

export default {
  [types.RESET](state: any) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      retrieved: null,
      updated: null,
      violations: null,
    });
  },

  [types.SET_ERROR](state: any, error: any) {
    Object.assign(state, { error });
  },

  [types.TOGGLE_LOADING](state: any) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },

  [types.SET_RETRIEVED](state: any, retrieved:Feed) {
    Object.assign(state, { retrieved });
  },

  [types.SET_UPDATED](state: any, updated:Feed) {
    Object.assign(state, { error: "", updated, violations: null });
  },

  [types.SET_VIOLATIONS](state: any, violations: any) {
    Object.assign(state, { violations });
  },

  [types.UPDATE_RETRIEVED](state: any, updated:Feed) {
    Object.assign(state.retrieved, updated);
  },
};
